module.exports = __webpack_public_path__ + "img/favicon.b842dbc2.svg";